import { getCount, index, post, put } from "src/api/notification";
import BrandForm from "src/modules/brand/components/BrandForm.vue";

const getInitialState = () => {
  return {
    notificationsCount: 0,
    notifications: [],
    notification: {},
  };
};

export const useNotificationStore = defineStore("notification", () => {
  const init = async () => {
    try {
      await getNotificationsCount();
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const formState = ref({
    edit: false,
    open: false,
  });

  const toggleNotificationForm = (state = {}) => {
    state = { edit: false, open: !formState.value.open, ...state };

    const { toggleRightDrawer } = useAppStore();

    toggleRightDrawer(state.open, BrandForm);

    formState.value = state;
  };

  let state = reactive(getInitialState());

  const getNotificationsCount = async () => {
    try {
      const { user } = storeToRefs(useAuthStore());

      const response = await getCount({
        params: { receiver: unref(user)?._id },
      });

      state.notificationsCount = response.data?.data;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const getNotification = (id) => {
    state.notification = state.notifications?.find(
      (notification) => notification._id === id,
    );
  };

  const { filter, pagination, params } = usePagination();

  const getNotifications = async (options = {}) => {
    try {
      const { user } = storeToRefs(useAuthStore());

      const response = await index({
        params: {
          ...unref(params),
          receiver: unref(user)?._id,
          ...unref(options)?.params,
        },
      });

      state.notifications = response.data?.data?.data;

      pagination.value.rowsNumber = response.data?.data?.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postNotification = async (notification) => {
    try {
      const response = await post(notification);

      await getNotifications();

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const putNotification = async (notification) => {
    try {
      const { user } = storeToRefs(useAuthStore());

      const response = await put({
        ...notification,
        receiver: unref(user)?._id,
      });

      await Promise.all([getNotificationsCount(), getNotifications()]);

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    formState,
    toggleNotificationForm,

    filter,
    pagination,

    ...toRefs(state),

    getNotification,
    getNotifications,
    getNotificationsCount,
    postNotification,
    putNotification,

    init,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useNotificationStore, import.meta.hot),
  );
}
